import { useEffect, useRef, useCallback, useState } from "react";
import SvgMapper from "../features/common/SvgMapper";
import "../features/common/Style.css";
import "./Style.css";

const RightSideComponent = ({ recentInterviews, isLoading, hasMore, onLoadMore }) => {
  const listRef = useRef(null);
  const observerRef = useRef(null);
  const [displayLimit, setDisplayLimit] = useState(6);

  useEffect(() => {
    if (recentInterviews?.length > displayLimit) {
      setDisplayLimit(prev => Math.min(prev + 6, recentInterviews.length));
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recentInterviews?.length]);

  const displayedInterviews = recentInterviews?.slice(0, displayLimit) || [];

  const lastItemRef = useCallback((node) => {
    if (isLoading) return;
    if (observerRef.current) observerRef.current.disconnect();
    
    observerRef.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        if (displayLimit < recentInterviews.length) {
          setDisplayLimit(prev => Math.min(prev + 6, recentInterviews.length));
        } 
        else if (hasMore && !isLoading) {
          onLoadMore();
        }
      }
    });
    
    if (node) observerRef.current.observe(node);
  }, [isLoading, hasMore, onLoadMore, displayLimit, recentInterviews]);

  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="dashboard-recent-interviews-container">
      <h3 className="dashboard-recent-interviews-title flex items-center gap-2">
        <span>Recent Interviews</span>
      </h3>
      <div 
        ref={listRef}
        className="dashboard-recent-interviews-list custom-scrollbar overflow-y-auto pr-2"
        style={{ height: '480px' }}
      >
        {displayedInterviews.length > 0 && displayedInterviews.map((activity, index) => {
          const isLastItem = index === displayedInterviews.length - 1;
          return (
            <div
              key={index}
              ref={isLastItem ? lastItemRef : null}
              className="dashboard-recent-interview-item"
            >
              <div className="dashboard-recent-interview-icon">
                {SvgMapper.interviewIcon()}
              </div>
              <div className="dashboard-recent-interview-content">
                <p className="dashboard-recent-interview-name">
                  {activity?.student_name}
                </p>
                <p className="dashboard-recent-interview-details">
                  {activity?.interview_type}
                </p>
              </div>
              <p className="dashboard-recent-interview-time">{activity?.time_ago}</p>
            </div>
          );
        })}
        {isLoading && (
          <div className="dashboard-recent-interview-item" style={{ justifyContent: 'center' }}>
            <p style={{ color: '#9ca3af', fontSize: '0.875rem' }}>Loading more...</p>
          </div>
        )}
        {!hasMore && recentInterviews?.length > 0 && displayLimit >= recentInterviews.length && (
          <div className="dashboard-recent-interview-item" style={{ justifyContent: 'center' }}>
            <p style={{ color: '#9ca3af', fontSize: '0.875rem' }}>No more interviews to load</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RightSideComponent;
